<template>
  <div>
    <div class="d-flex justify-content-end">
      <img width="150" :src="`https://storage.googleapis.com${data.form.application.logo}`"  alt="Logo courier" class="m-1">
    </div>
    <UiNotice v-bind="noticePresets.tariffsExportInfo">
      <li>Para obtener toda la información de las tarifas de un lugar de origen, puede descargarla presionando el botón "Exportar excel".</li>
    </UiNotice>
    <span class="d-flex justify-content-between m-1">
      <li class="ml-1 align-content-center">Días de preparación: <strong>{{ data && data.rates && data.rates.handlingTime }}</strong></li>
      <div class="d-flex">
        <b-form-checkbox switch v-model="checked" class="checkbox-switch-table-custom-tariff custom-switch-success" @change="changeChecked">{{checked ? 'Activa' : 'Inactiva'}}</b-form-checkbox>
        <b-button variant="outline-success" @click="exportExcel" :disabled="loading.exportExcel">
          <feather-icon icon="DownloadIcon" class="mr-1 ml-0" v-if="!loading.exportExcel"/>
          <b-spinner v-if="loading.exportExcel" small/>
          Exportar excel
        </b-button>
      </div>
    </span>
    <table-render
      :key="keyTableRender"
      id="table"
      :rows="rows"
      :schema="schema"
      class="m-2"
      @moreActions="moreActions"
    />
    <pagination :pagination="pagination" :showSize="true" :showDigits="true" v-if="data && data.rows && data.rows.length > pagination.limit"/>
  </div>
</template>
<script>
import BaseServices from '@/store/services/index'
import UiNotice from '@/views/components/custom/ui-notice/UiNotice.vue'
import { noticePresets } from '@/views/components/custom/ui-notice/noticePresets.js'

export default {
  name: '',
  components: { UiNotice },
  props: ['data', 'openModal', 'getRates'],
  data() {
    return {
      baseService: new BaseServices(this),
      keyTableRender: 0,
      rows: [],
      schema: [],
      pagination: {
        page: 1,
        total: 20,
        limit: 10
      },
      loading: {exportExcel: false},
      checked: !!(this.data.rates?.isActive),
      countrySchemas: {
        CL: [
          { label: 'Región', key: 'level2' },
          { label: 'Comuna', key: 'level0' }
        ],
        CO: [
          { label: 'Código', key: 'dest_place_code' },
          { label: 'Departamento', key: 'level2' },
          { label: 'Municipio', key: 'level0' }
        ],
        MX: [
          { label: 'CP', key: 'level0' },
          { label: 'Estado', key: 'level2' },
          { label: 'Municipio', key: 'level1' }
        ],
        PE: [
          { label: 'Ubigeo', key: 'level0' },
          { label: 'Departamento', key: 'level3' },
          { label: 'Provincia', key: 'level2' },
          { label: 'Distrito', key: 'level1' }
        ]
      },
      noticePresets
    }
  },
  methods: {
    setInitialData() {
      this.schema = this.setSchema()
      this.rows = this.data.rows
      this.keyTableRender++
    },
    setSchema() {
      const countryCode = this.data?.form?.countryIdSeller?.code
      const weightIntervals = this.data?.rows[0]?.weight_intervals
      let schema = []

      // Asignar esquema base según el código del país
      if (countryCode && weightIntervals) {
        schema = this.countrySchemas[countryCode] || []
      }
      // Agregar campos comunes si hay intervalos de peso
      if (weightIntervals) {
        schema.push({ label: 'Valor mínimo envío gratis', key: 'formatted_free_shipping_minimum_value' })
        const arrayWeightIntervals = Object.keys(weightIntervals)
          .map(key => parseFloat(key)) // Convertir a número
          .sort((a, b) => a - b) // Ordenar de menor a mayor
        // Agregar columnas dinámicas para intervalos de peso
        arrayWeightIntervals.forEach(weight => {
          schema.push({
            label: `Precio (${weight}kg)`,
            key: `${weight}`,
            class: ['text-right']
          })
        })
        // Agregar acciones adicionales
        const moreActions = [
          { key: 'moreActions', icon: 'MoreVerticalIcon', moreActions: true, options: [{ text: 'Eliminar tarifa', id: 'delete' }, { text: 'Editar tarifa', id: 'edit' }] },
          { key: 'moreActions', icon: 'MoreVerticalIcon', moreActions: true, options: [{ text: 'Editar tarifa', id: 'edit' }] }
        ]
        schema.push(...moreActions)
      }

      return schema
    },
    changeChecked() {
      const params = {
        action: this.checked ? 'activate' : 'deactivate',
        rate_id: this.data.rates.id
      }
      const data = {}
      this.baseService.callService('putActivateTariff', data, params)
        .then(() => {
          this.$newSuccess('Solicitud realizada con exito', `La tarifa se ha ${this.checked ? 'activado' : 'desactivado'}`, 'medium')
          this.$emit('getRates', true)
        })
        .catch((err) => {
          this.$alert('Error al realizar lo solicitud', {code: err})
        })
    },
    moreActions(action) {
      if (action?.id === 'delete') {
        this.confirmDeleteTariff()
      } else if (action?.id === 'edit') {
        this.editTariff()
      }
    },
    confirmDeleteTariff() {
      const confirmTitle = 'Eliminar tarifa'
      const confirmMsg = '¿Está seguro que desea eliminar toda la tarifa?'
      this.$confirm(confirmMsg, this.deleteTariff, confirmTitle, 'Sí', 'No')
    },
    deleteTariff() {
      const params = {
        customized_rate_id: this.data.rates.id
      }
      const data = {}
      this.baseService.callService('deleteCustomizedRates', data, params)
        .then(() => {
          this.$newSuccess('Tarifa eliminada', 'La tarifa ha sido eliminada con éxito', 'medium')
          this.$emit('getRates', {isEdit: false, isDelete: true})
        })
        .catch((err) => {
          this.$alert('Error al realizar lo solicitud', {code: err})
        })
    },
    editTariff() {
      this.$emit('openModal', false)
    },
    exportExcel() {
      this.loading.exportExcel = true
      const params = {customized_rate_id: this.data.rates.id}
      const props = {
        name: 'exportCustomizedRates',
        fileName: `Tarifas ${this.data.rates.companyName}, ${this.data.rates.marketCenterName}`,
        params,
        onSuccess: () => {
          this.loading.exportExcel = false
          this.$newSuccess('¡Descarga Ok!', 'El archivo de Tarifas ha sido descargado con éxito.')
        },
        onError: (err) => {
          this.loading.exportExcel = false
          this.$alert(this.$t('¡Error!, Ha ocurrido un error al descargar el archivo de Tarifas.', {code: err}))
        }
      }
      this.$store.dispatch('fetchServiceGenerateExcel', props)
    }
  }
}
</script>
<style lang="scss">
  .checkbox-switch-table-custom-tariff {
    margin-right: 10px;
    align-content: center;
    label {
      margin-bottom: 0 !important;
    }
  }
</style>

